import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the gift card page a "Gift cards" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/gift-cards')({
  staticData: { crumb: 'common:nav.giftCards' },
  component: Outlet,
});
